import { defineStyle } from '@chakra-ui/react';

export const MenuTitleStyles = defineStyle({
  display: 'flex',
  flexWrap: 'wrap',
  gap: 2,
  alignItems: 'center',
});
